import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import { H } from 'highlight.run';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import getHighlightConfig from './config/highlight';
import './i18n/i18n.js';
import i18n from './i18n/i18n.js';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './safeArea.css';
import customTheme from './theme';

// Highlight.io 초기화 - 환경별 설정 적용
const highlightConfig = getHighlightConfig();

function maybeCleanupHighlightSessionData(config) {
  try {
    if (config && config.disableSessionRecording) {
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i += 1) {
        const key = localStorage.key(i);
        if (!key) continue;
        if (key.startsWith('sessionData_') || key.startsWith('highlightSession')) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((key) => localStorage.removeItem(key));
    }
  } catch {
    // ignore storage access errors
  }
}

if (process.env.REACT_APP_DEPLOY_ENV !== 'local') {
  const { projectId, ...config } = highlightConfig;
  maybeCleanupHighlightSessionData(config);
  H.init(projectId, config);

  // Sentry 초기화 - 환경별 설정 적용
  Sentry.init({
    dsn: 'https://ebf0bb8a73b3c7d6a85d88457eeb3fb5@o4505141831270400.ingest.sentry.io/4505737498394624',
    environment: process.env.REACT_APP_DEPLOY_ENV,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          'localhost',
          'http://api.pocapan.com',
          'http://dev-api.pocapan.com/'
        ]
      }),
      new Sentry.Replay()
    ],
    // Performance Monitoring - 환경별 Sample Rate 적용
    tracesSampleRate: process.env.REACT_APP_DEPLOY_ENV === 'production' ? 0.05 : 0.5,
    // Session Replay - Development에서는 비활성화
    replaysSessionSampleRate: process.env.REACT_APP_DEPLOY_ENV === 'production' ? 0.01 : 0,
    replaysOnErrorSampleRate: process.env.REACT_APP_DEPLOY_ENV === 'production' ? 0.01 : 0
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <I18nextProvider i18n={i18n}>
      <ChakraProvider theme={customTheme}>
        <ColorModeScript initialColorMode={customTheme.config.initialColorMode} />
        <App />
      </ChakraProvider>
    </I18nextProvider>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
